import { dashboardTasksRetrieveOptions } from '@crm/api'
import { TaskCard } from '@crm/components'
import { useStyles } from '@crm/features/dashboard/styles'
import { useQueryParams } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Col, Row, Spin } from 'antd'

export const TasksCards = () => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const { params } = useQueryParams()

  const { data, isLoading } = useQuery(
    dashboardTasksRetrieveOptions({
      query: params
    })
  )

  const tasksData = data?.user ?? {
    past_tasks: { total_tasks: 0, tasks: [] },
    current_tasks: { total_tasks: 0, tasks: [] },
    future_tasks: { total_tasks: 0, tasks: [] }
  }

  return (
    <Spin spinning={isLoading}>
      <Row gutter={[8, 8]} className={styles.tasksCards}>
        <Col span={24} xxl={8}>
          <TaskCard
            type="expired"
            description={t('logs.expired')}
            user={tasksData}
          />
        </Col>

        <Col span={24} xxl={8}>
          <TaskCard
            type="current"
            description={t('logs.current')}
            user={tasksData}
          />
        </Col>

        <Col span={24} xxl={8}>
          <TaskCard
            type="future"
            description={t('logs.future')}
            user={tasksData}
          />
        </Col>
      </Row>
    </Spin>
  )
}
